export default "__VITE_ASSET__B5_fRKvd__"